/**
 * Objeto MiaQuery sin la funcionalidad del MiaQuery original. La api está hecha con esto así que hay que usarlo como está, asignando los campos a mano, o con algún método si es necesario, pero por ahora no quiero
 */
export class QueryOptions {
	page? : number;
	wheres? : Where[];
	joins? : Join[];
	withs? : string[];
	search? : string;
	orders? : Order[];
	limit? : number;
}
export class Join {
	table! : string;
	column! : string;
	relation! : string;
}
export class Where {
	type : "equal"|"in";
	key : string;
	value : any;

	constructor(type:"equal"|"in", key:string, value:any) {
		this.type = type;
		this.key = key;
		this.value = value;
	}
}
export class Order {
	field! : string;
	type! : "asc"|"desc";

	constructor(field:string, type:"asc"|"desc") {
		this.field = field;
		this.type = type;
	}
}